import { render, staticRenderFns } from "./ModalEnviarAtaPncp.vue?vue&type=template&id=b7f37c8a&scoped=true"
import script from "./ModalEnviarAtaPncp.vue?vue&type=script&lang=js"
export * from "./ModalEnviarAtaPncp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f37c8a",
  null
  
)

export default component.exports